// Number of previous jobs loaded per page in the "Load from previous job" step.
// Kept small so the step resolves quickly; more can be loaded on demand.
export const PREVIOUS_JOBS_PAGE_SIZE = 3;
